exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-layout[data-v-6599bed6]{position:relative;width:100%;height:100%}.brand[data-v-6599bed6]{position:absolute;bottom:30px;color:#999;font-size:12px;left:50%;transform:translateX(-50%)}", ""]);

// exports
